import { showToast } from './toast';
import fetchApi from './fetchApi';

const getValidationMessage = (detail) => {
	if (!detail) return null;
	if (typeof detail === 'string') return detail;
	if (Array.isArray(detail) && detail.length) return detail[0];
	if (typeof detail === 'object') {
		const values = Object.values(detail);
		if (values.length) return values[0];
	}
	return null;
};

export async function handleFetch({
	url,
	method = 'GET',
	body = {},
	isFormData = false,
	headers,
	onSuccess,
	onValidationError,
	showErrorToast = true,
}) {
	try {
		const response = await fetchApi[method.toLowerCase()](url, body, isFormData, headers);

		const { status, message, data, code, detail } = response;

		if (status === 'success') {
			onSuccess?.(data, message);
			return true;
		}

		if (status === 'error') {
			if (code === 422) {
				onValidationError?.(detail);
				if (showErrorToast) {
					const validationMessage = getValidationMessage(detail);
					showToast.error(validationMessage || message || 'Validation failed');
				}
			} else {
				if (showErrorToast) showToast.error(message || 'Something went wrong');
			}
			return false;
		}

		if (showErrorToast) showToast.error('Unexpected response');
		return false;
	} catch (error) {
		console.error('error', error);
		if (showErrorToast) showToast.error(error.message || 'Request failed');
		return false;
	}
}
